const Keyword = () => {
  // placeholder for Keyword filter
  return <div></div>
}

export { Keyword }